import {HttpClient} from "@web-libs/core/http/api/http.client";
import {HttpHeaders} from "@web-libs/core/http/api/http.types";
import baseUrl from "@web-libs/core/http/infrastructure/server-side/_base-url";
import {_fetch} from "@web-libs/core/http/infrastructure/server-side/_fetch-method";
import {createHttpClient} from "@web-libs/core/http/infrastructure/shared/create-http";

export const createFetchBasedHttpClient = (defaultHeaders?: HttpHeaders, tenantId?:string, lang?: string): HttpClient => {
    return createHttpClient(baseUrl!, _fetch, defaultHeaders, tenantId, lang)
}

export const createTenantAwareFetchBasedHttpClient = (tenantId: string, lang?: string): HttpClient => {
    return createFetchBasedHttpClient({}, tenantId, lang)
}
